import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useModals } from 'almanac-ui/Modal'
import { useAlmanacEditorState } from 'stores/EditorState'
import { useRootStore } from 'stores/RootStore'
import { TurnInto as TurnIntoIcon } from 'blaze-ui/icons/36'
import { AIAssistantProps } from '../Types'
import { Action, ActionProps } from './Action'
import { TurnIntoWizard } from 'components/Wizards/TurnInto/TurnIntoWizard'
import { SourceType } from 'components/Wizards/TurnInto/Source/Types'
import { markdownSerializer } from 'common/Prose/components/TextInlineFormatBar/components/FormatBars/markdownSerializer'
import cx from 'classnames'
import { usePaywallGuard } from 'hooks/usePaywallGuard'

export const TurnInto = observer(function TurnInto({
  article,
  layerId,
  className,
  ...props
}: Omit<ActionProps, 'label' | 'tooltip'> & AIAssistantProps) {
  const { openModal } = useModals()
  const { docStore } = useRootStore()
  const editorState = useAlmanacEditorState()

  const containsAiSuggestionNode = computed(() =>
    editorState?.allNodeTypes.has(editorState.view.state.schema.nodes.ai_suggestion),
  ).get()

  const selection = editorState?.selection
  const doc = editorState?.view.state.doc

  const documentAsMarkdown = doc ? markdownSerializer.serialize(doc) : undefined

  const handlePress = () => {
    if (!editorState) return

    docStore?.rightRailStore.setActiveTab(undefined)
    openModal(TurnIntoWizard, {
      sourceType: SourceType.File,
      fromDocProps: {
        documentAsMarkdown,
        selection,
      },
    })
  }

  const guardedHandlePress = usePaywallGuard(handlePress)

  return (
    <Action
      label="Turn Into"
      tooltip="Create ads, social posts, emails, and more from your doc"
      icon={TurnIntoIcon}
      isDisabled={!editorState || containsAiSuggestionNode}
      {...props}
      className={cx(className, 'blog-post-output-tour-4')}
      onPress={guardedHandlePress}
    />
  )
})
